export default "__VITE_ASSET__Bmza22gp__"